﻿import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

export default function PedigreeLayout() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        minHeight: 0,
        overflow: 'hidden',
      }}
    >
      {/* Common elements for all pedigree routes */}
      <Outlet /> {/* This renders the child routes */}
    </Box>
  );
}
